








import { Component, Mixins } from 'vue-property-decorator';
import PageInfo from '@/components/page/organization/info';
import CardMixin from '../common';

@Component({
  components: { PageInfo },
})
export default class PageActivityCardResult extends Mixins(CardMixin) {
  // Computed
  get hasContent() {
    return !!this.html;
  }

  get html() {
    return this.activity.results;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/activities/card/result/component.vue